module.exports = __webpack_public_path__ + "img/18.ee48b167.jpg";